<template>
  <v-card class="bienestar pb-1" elevation="9">
    <div class="bienestar-title">
      <h2 class="bienestar-title-txt pt-1">Opciones</h2>
    </div>
    <div class="bienestar-body">
      <div class="bienestar-body-intro">
        <p>
          Los colaboradores son la piedra angular de la empresa, así mismo lo más importante para ésta institución. Es por eso, que se les brindan excelentes paquetes de beneficios y prestaciones que a continuación serán descritos.
        </p>
      </div>
    </div>
    <div class="bienestar-body-content">
      <v-row no-gutters>
        <v-col cols="12">
          <v-timeline dense>
            <!--SEGURO DE AUTO-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-car</v-icon> <span class="bienestar-epit">Seguro de Automóvil</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        Solicita tu cotización de seguro de auto en línea y aseguralo, mediante el Sistema de Cotización y Compra de Seguro de Autos.
                      </p>
                      <p>
                        <ol>
                          <li>Captura tu número de empleado y RFC (incluyendo homoclave).</li>
                          <li>Si es la primera vez que ingresas te pedirá aceptar el Contrato de confidencialidad y es necesario dar clic en Mi Información en donde tendrás que capturar tus datos personales y dar clic en Guardar (esta información se plasmara en las pólizas que emitas, por lo que te recomendamos capturar información real).</li>
                          <li>Selecciona la opción Cotizar mi Seguro listo.</li>
                          <li>Proporciona los datos del vehículo y da clic en Continuar.</li>
                          <li>Para informarte sobre las coberturas de la póliza y el detalle de los pagos quincenales da clic en Imprime tu cotización. Selecciona el tipo de póliza (amplia, limitada o responsabilidad civil) y da clic en Continuar.</li>
                          <li>Ingresa los datos solicitados del vehículo y da clic en Continuar.</li>
                          <li>Verifica los datos y da clic en Continuar.</li>
                          <li>Ingreso el instrumento de pago (tarjeta débito, crédito o cuenta clabe).</li>
                          <li>Imprime tu póliza.</li>
                        </ol>
                      </p>
                      <div class="bienestar-body-opt">
                        <!--
                          <v-btn text @click="goToLink('seguro_auto_manual')">
                            Ver manual
                          </v-btn>
                        -->
                        <v-btn text @click="goToLink('seguro_auto')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--PORTAL DE VACACIONES-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-white-balance-sunny</v-icon> <span class="bienestar-epit">Portal de Vacaciones</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        A continuación se mostrará una breve guía con los pasos a seguir para realizar éste proceso. Por favor da clic en el botón de abajo para poder visualizarla.
                      </p>
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('vacaciones_gs')">
                          Guía de solicitud
                        </v-btn>
                        <v-btn text @click="goToLink('vacaciones_ga')">
                          Guía de auorización
                        </v-btn>
                        <v-btn text @click="goToLink('vacaciones')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--SGMM-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-pulse</v-icon> <span class="bienestar-epit">Seguro de Gastos Médicos Mayores/Vida</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        A continuación se mostrará una breve guía con los pasos a seguir para realizar éste proceso. Por favor da clic en el botón de abajo para poder visualizarla.
                      </p>
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('sgmm')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--RECIBOS NOMINA-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-card-account-details</v-icon> <span class="bienestar-epit">Recibos de Nómina</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        Por favor da clic en el botón de abajo para redirigirte al sitio.
                      </p>
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('recibos_nomina_guia')">
                          Guía Recibos de Pago
                        </v-btn>
                        <v-btn text @click="goToLink('recibos_nomina')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--STB-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-tree</v-icon> <span class="bienestar-epit">Sitio de Bienestar Total</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff; text-align: center">
                      <img class="home-body-content-img" :src="require('@/assets/img/sbt.jpg')">
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('sitio_bt')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--CONVENIOS UVM-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-handshake</v-icon> <span class="bienestar-epit">Convenios UVM</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        Por favor da clic en el botón de abajo para redirigirte al sitio.
                      </p>
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('convenios_uvm')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>
            <!--CONVENIOS UNITEC-->
              <v-timeline-item
                small
                fill-dot
                color="success"
              >
                <v-expansion-panels>
                  <v-expansion-panel style="background:#4caf50">
                    <v-expansion-panel-header>
                      <h3>
                        <v-icon class="bienestar-epii">mdi-handshake</v-icon> <span class="bienestar-epit">Convenios UNITEC</span>
                      </h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="color:#fff">
                      <p>
                        Por favor da clic en el botón de abajo para redirigirte al sitio.
                      </p>
                      <div class="bienestar-body-opt">
                        <v-btn text @click="goToLink('convenios_unitec')">
                          Ir al sitio
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-timeline-item>

          </v-timeline>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'Home',
    data(){
      return{
        items: [
          {
            id: 1,
            color: 'info',
            icon: 'mdi-information',
          },
        ],
      }
    },
    methods:{
      goToLink(opt){
        let url = "";
        //
        if(opt==='seguro_auto_manual'){
          url = "https://miespaciolaureate.com/media/intranet/"
        }
        else if(opt==='seguro_auto'){
          url = "http://seguroslaureate.Inter.mx "
        }
        else if(opt==='vacaciones_gs'){
          url = "https://miespaciolaureate.com/media/intranet/videos/solicitud_vacaciones.mp4"
        }
        else if(opt==='vacaciones_ga'){
          url = "https://miespaciolaureate.com/media/intranet/videos/autorizacion_vacaciones.mp4"
        }
        else if(opt==='vacaciones'){
          url = "https://hcm.ps.laureate.mx/psp/leihrprd/?cmd=login&languageCd=ESP&"
        }
        else if(opt==='sgmm'){
          url = "http://seguroslaureate.Inter.mx"
        }
        else if(opt==='recibos_nomina_guia'){
          url = "https://miespaciolaureate.com/media/intranet/videos/recibos_nomina.mp4"
        }
        else if(opt==='recibos_nomina'){
          url = "https://hcm.ps.laureate.mx/psp/leihrprd/?cmd=login"
        } 
        else if(opt==='sitio_bt'){
          url = "https://salud.bienestar-total.com.mx/pro/acceso"
        }
        else if(opt==='convenios_uvm'){
          url = "https://rewards.uvm.mx/"
        }
        else if(opt==='convenios_unitec'){
          url = "https://www.unitec.mx/descuentos-empresariales/"
        }
        window.open(url, "_blank");
      }
    },
    //
    created(){
      if(!this.$msal.isAuthenticated()){
        this.$router.replace('login')
      }
    }
  }
</script>
